import React, { useEffect, useState } from 'react';
import partyPopper from 'assets/images/party-popper.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/help-icon-circle.svg';
import { useNavigate, useParams } from 'react-router-dom';
import authService from 'services/auth.service';
import { ROUTE_KEYS } from 'utils/constants';
import { Button } from '@cokitchen/cokitchen-components';

const VerifyNewAccountEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = () => {
    navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`);
  };
  const verifyToken = async () => {
    try {
      const response = await authService.confirmEmail({ token });
      if (response?.status === 201) {
        setSuccess(true);
      } else {
        setSuccess(false);
        setError('Email verification failed');
      }
    } catch (err: any) {
      setSuccess(false);
      setError(err?.response?.data?.message || 'An error occured');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.clear();
    if (token) verifyToken();
  }, [token]);

  const loginButton = (
    <Button
      className='max-w-[390px] mx-auto'
      color='primary'
      small
      variant='block'
      onClick={handleConfirm}>
      Proceed to Login
    </Button>
  );

  return (
    <div className='w-full h-[100vh] flex flex-col'>
      <div className='w-full flex items-center gap-3 px-3 py-[26px] border-b border-[#EFF0F0] md:px-[50px]'>
        <HelpIcon className='w-[30px] h-[30px] p-[6px] rounded-full bg-[#F4F1F1]' />
        <p className='text-[#2E3031] text-sm'>
          Need Help ? <span className='text-[#5E6164]'>contact us</span>
        </p>
      </div>

      <div className='max-w-[394px] h-[80vh] mx-auto flex flex-col gap-8 items-center justify-center px-3'>
        {loading ? (
          <p>Verifying your email...</p>
        ) : success ? (
          <>
            <img
              src={partyPopper}
              className='w-[140px] h-[140px] pt-8 pr-8 rounded-full bg-[#FFF4E5]'
            />
            <article className='flex flex-col gap-3 text-center'>
              <h2 className='text-xl font-semibold'>Email Verification Complete</h2>
              <p className=' text-[#6F7376] text-center pb-3'>Your email has been verified!</p>
            </article>
            {loginButton}
          </>
        ) : (
          <article className='flex flex-col gap-3 text-center'>
            <h2 className='text-xl font-semibold'>Email Verification Failed</h2>
            <p className=' text-[#6F7376] text-center pb-3'>{error}</p>
            {error === 'You have already been verified' ? loginButton : null}
          </article>
        )}
      </div>
    </div>
  );
};

export default VerifyNewAccountEmail;
